/**
 * Sends the current page (path + query) to Hulk Form Builder iframes, so forms
 * with a `hulk-source-url` field record which page they were submitted from.
 *
 * Hulk runs a form's Advanced JS late (Rocket Loader), so the form asks for the
 * URL with a `hulkSourceUrlRequest` message once its listener is ready, and this
 * script replies. The send on iframe load stays as a fallback.
 * Forms without that field and listener ignore the message.
 */
(() => {
  const HULK_ORIGIN = 'https://formbuilder.hulkapps.com';
  const SOURCE_URL_REQUEST = 'hulkSourceUrlRequest';
  const SEND_DELAY_MS = 500;

  const getSourceUrl = () => window.location.pathname + window.location.search;

  const isHulkIframe = (el) => el instanceof HTMLIFrameElement && el.src.startsWith(HULK_ORIGIN);

  const sendSourceUrl = (target) => {
    if (!target) return;

    target.postMessage({ sourceUrl: getSourceUrl() }, HULK_ORIGIN);
  };

  window.addEventListener('message', (event) => {
    if (event.origin !== HULK_ORIGIN || event.data?.type !== SOURCE_URL_REQUEST) return;

    sendSourceUrl(event.source);
  });

  // Iframe load events don't bubble but can be captured, which also covers iframes added or reloaded later.
  document.addEventListener(
    'load',
    (event) => {
      if (isHulkIframe(event.target)) setTimeout(() => sendSourceUrl(event.target.contentWindow), SEND_DELAY_MS);
    },
    true
  );

  // Covers iframes that finished loading before this deferred script ran.
  document.querySelectorAll(`iframe[src^="${HULK_ORIGIN}"]`).forEach((iframe) => sendSourceUrl(iframe.contentWindow));
})();
